import { IssueStatus } from '@cims-online/shared'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSSelect from 'components/CIMSSelect'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
import { useEditIssueModalIssueTypesQuery } from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { HelpMessage } from 'utils/constants'
import { Issue } from '../../../../../../IssueTrackerContext/types'
import { useDisabledOptions } from 'hooks/useDisabledOptions'
import { useProjectContext } from 'context/ProjectContext'

const IssueTypes: React.VFC<Pick<Issue, 'statusId'>> = ({ statusId }) => {
  const { projectId } = useProjectContext()
  const { data, loading } = useEditIssueModalIssueTypesQuery({
    ...DefaultQueryHookOptions,
    variables: { projectId },
  })
  const [disabled, { some }] = useDisabledOptions([
    {
      disabled: statusId === IssueStatus.PendingClosure.id,
      reason: {
        why: 'invalid status',
        statusName: IssueStatus.PendingClosure.name,
      },
    },
    {
      disabled: statusId === IssueStatus.Closed.id,
      reason: { why: 'invalid status', statusName: IssueStatus.Closed.name },
    },
    {
      disabled: statusId === IssueStatus.Unlocked.id,
      reason: { why: 'invalid status', statusName: IssueStatus.Unlocked.name },
    },
  ])
  return (
    <CIMSFormItem
      label="Types"
      name="types"
      help={HelpMessage.Issues.IssueTracker.Types}
      requiredMessage={
        statusId !== IssueStatus.Draft.id
          ? 'Please enter at least one type'
          : undefined
      }
      disabled={disabled}
    >
      <CIMSSelect
        mode="multiple"
        loading={loading}
        options={useOptions({
          items: data?.issueTypes?.records,
          sort: 'name',
          label: 'name',
          value: 'id',
          tooltip: 'description',
        })}
        disabled={some}
      />
    </CIMSFormItem>
  )
}

export default IssueTypes
